import gsap from 'gsap';
import ScrollMagic from 'scrollmagic';

const home = () => {
  const heroTitle = document.querySelector('.hero__title');
  const intro = document.querySelector('.hero__intro');
  const mouse = document.querySelector('.hero__mouse');
  const plan = document.querySelector('.plan');
  
  if (!heroTitle || !intro || !mouse || !plan) {
    return;
  }

  const span = heroTitle.querySelectorAll('span');
  const controllerHero = new ScrollMagic.Controller();

  const tweenTitle = gsap.timeline();
  tweenTitle
  .to(span, {y: 0, opacity: 1, duration: 0.3, ease: "expo", stagger: 0.2}, "-= 0.2")
  .to(intro, {y: 0, opacity: 1, duration: 0.3, ease: "expo"}, "-= 0.2")
  .delay(0.7);

  new ScrollMagic.Scene({
    triggerElement: plan,
    offset: 0,
    reverse: true
  })
  .on('enter', () => {
     mouse.style.display = 'none';
  })
  .on('leave', () => {
    mouse.style.display = 'inherit';
  })
  .addTo(controllerHero);
}

export default home;


